<coa-dashboard-location-preferences-list
  *ngIf="showList$ | async"
  [clientLocationPreferences]="clientLocationPreferences"
  class="dashboard-location-preferences-list">
</coa-dashboard-location-preferences-list>

<coa-dashboard-location-preferences-chart
  *ngIf="showChart$ | async"
  [clientLocationPreferences]="clientLocationPreferences"
  class="dashboard-location-preferences-chart">
</coa-dashboard-location-preferences-chart>

<coa-dashboard-location-preferences-skeleton
  *ngIf="showSkeleton$ | async"
  class="dashboard-location-preferences-skeleton">
</coa-dashboard-location-preferences-skeleton>

<coa-dashboard-location-preferences-error
  *ngIf="showError$ | async"
  class="dashboard-location-preferences-error">
</coa-dashboard-location-preferences-error>

<coa-dashboard-location-preferences-empty
  *ngIf="showEmpty$ | async"
  class="dashboard-location-preferences-empty">
</coa-dashboard-location-preferences-empty>
